import { useMemo } from 'react';
import { getRefereeData, setRefereeCookie, unsetRefereeCookie } from 'js/utils/referrer.util';

export const useReferrerPublicAPI = () => {

    return useMemo(() => ({
        /**
         * Get referee value from the cookie.
         * @memberOf Playtech.API.referrer
         * @function
         * @param {string} [cookieName] If unset, referrer cookie is used.
         * @returns {string}
         * @example
         * Playtech.API.referrer.getRefereeData('cookieName')
         */
        getRefereeData,
        /**
         * Set cookie if pointed cookie doesn't exist yet.
         * @memberOf Playtech.API.referrer
         * @function
         * @param {Object} options Source of pointed cookie value.
         * @param {string} [cookieName=referrer] If unset, referrer cookie is used.
         * @example
         * Playtech.API.referrer.setRefereeCookie({newCookie: '1'}, 'newCookie');
         */
        setRefereeCookie,
        /**
         * Unset a referee cookie.
         * @memberOf Playtech.API.referrer
         * @function
         * @param [cookieName] {string} If unset, referrer cookie is used.
         * @example
         * Playtech.API.referrer.unsetRefereeCookie('cookieName')
         */
        unsetRefereeCookie
    }), []);
};
